"use client"

import { forwardRef } from "react"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

// Centralized date range constants for the DLOM calculator
export const DATE_RANGE = {
  MIN: "2005-01",
  MAX: "2025-12",
} as const

export type YearMonthPickerProps = React.InputHTMLAttributes<HTMLInputElement>

const YearMonthPicker = forwardRef<HTMLInputElement, YearMonthPickerProps>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="month"
        min={DATE_RANGE.MIN}
        max={DATE_RANGE.MAX}
        className={cn("font-mono", className)}
        {...props}
      />
    )
  }
)
YearMonthPicker.displayName = "YearMonthPicker"

export { YearMonthPicker }